import React, { useState } from 'react';
import classnames from 'classnames';
import { ModelEditorFactory, ModelTypeSelector } from '@leverege/ui-plugin';
import { useValueChange } from '@leverege/ui-hooks';
import { IdGen, Pane, Label, TextInput, Selector, Checkbox, Flex, NumericInput } from '@leverege/ui-elements';
import { ns } from '@leverege/i18n';
import { Colorizers } from '@leverege/ui-attributes';
import Model from "./ImageDetailModel.js";
import S from './Editor.css';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const {
  t: uiAttributesT
} = ns('ui-attributes.detail.type.AttributeDetailEditor');
const {
  t
} = ns('molten.imagine.attributes.resourceImage.ResourceImageDetailModelEditor');
function AttributeDetailEditor(props) {
  const {
    value,
    objectType
  } = props;
  const {
    type
  } = value;
  const onModelChange = useValueChange(Model, props);
  const [ids] = useState(IdGen.createIds('attr', 8));
  if (value == null) {
    return null;
  }
  const formatter = Model.getFormatter(value);
  const formatterEditor = formatter && ModelEditorFactory.create(formatter, {
    eventData: 'setFormatter',
    onChange: onModelChange
  });
  const lFont = ModelEditorFactory.create(Model.getLabelFont(value), {
    eventData: 'setLabelFont',
    onChange: onModelChange
  });
  return /*#__PURE__*/_jsxs(Pane, {
    variant: "editor",
    className: S.grid,
    children: [formatterEditor && /*#__PURE__*/_jsx(Label, {
      className: S.fill,
      variant: "input",
      children: uiAttributesT('format')
    }), formatterEditor != null && /*#__PURE__*/_jsx("div", {
      className: classnames(S.fill, S.sub),
      children: formatterEditor
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "rowM",
      className: S.fill,
      children: [/*#__PURE__*/_jsx(Checkbox, {
        id: ids[0],
        variant: "small",
        value: Model.getLabelVisible(value),
        eventData: "setLabelVisible",
        onChange: onModelChange
      }), /*#__PURE__*/_jsx(Label, {
        htmlFor: ids[0],
        variant: "input",
        children: uiAttributesT('showLabel')
      })]
    }), Model.getLabelVisible(value) && /*#__PURE__*/_jsxs("div", {
      className: classnames(S.grid, S.fill, S.sub),
      children: [/*#__PURE__*/_jsx(Label, {
        variant: "input",
        htmlFor: ids[1],
        children: uiAttributesT('label')
      }), /*#__PURE__*/_jsx(TextInput, {
        id: ids[1],
        disabled: !Model.getLabelVisible(value),
        eventData: "setLabel",
        hint: uiAttributesT('labelHint'),
        value: Model.getLabel(value),
        onChange: onModelChange
      }), /*#__PURE__*/_jsx(Label, {
        variant: "input",
        htmlFor: ids[2],
        children: uiAttributesT('color')
      }), Model.getLabelVisible(value) && ModelTypeSelector.createSelectorAndEditor({
        editorProps: {
          id: ids[2],
          objectType
        },
        modelKey: 'colorizer',
        values: Colorizers.getColorizersFor(objectType),
        value: Model.getLabelColor(value),
        eventData: 'setLabelColor',
        onChange: onModelChange
      }, S.fill), lFont != null && /*#__PURE__*/_jsx(Label, {
        variant: "input",
        className: S.fill,
        children: uiAttributesT('font')
      }), lFont != null && /*#__PURE__*/_jsx("div", {
        className: classnames(S.fill, S.sub),
        children: lFont
      }), /*#__PURE__*/_jsx(Label, {
        variant: "input",
        children: uiAttributesT('justify')
      }), /*#__PURE__*/_jsx(Selector, {
        eventData: "setLabelJustify",
        value: Model.getLabelJustify(value),
        values: [{
          value: null,
          name: uiAttributesT('none')
        }, {
          value: 'left',
          name: uiAttributesT('left')
        }, {
          value: 'center',
          name: uiAttributesT('center')
        }, {
          value: 'right',
          name: uiAttributesT('right')
        }],
        onChange: onModelChange
      }), /*#__PURE__*/_jsx(Label, {
        variant: "input",
        children: uiAttributesT('align')
      }), /*#__PURE__*/_jsx(Selector, {
        eventData: "setLabelAlign",
        value: Model.getLabelAlign(value),
        values: [{
          value: null,
          name: uiAttributesT('none')
        }, {
          value: 'top',
          name: uiAttributesT('top')
        }, {
          value: 'center',
          name: uiAttributesT('center')
        }, {
          value: 'bottom',
          name: uiAttributesT('bottom')
        }],
        onChange: onModelChange
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "rowM",
        className: S.fill,
        children: [/*#__PURE__*/_jsx(Checkbox, {
          id: ids[5],
          variant: "small",
          value: Model.getLabelWrap(value),
          eventData: "setLabelWrap",
          onChange: onModelChange
        }), /*#__PURE__*/_jsx(Label, {
          htmlFor: ids[5],
          variant: "input",
          children: uiAttributesT('textWrap')
        })]
      })]
    }), /*#__PURE__*/_jsx(Label, {
      className: S.fill,
      variant: "input",
      children: uiAttributesT('value')
    }), /*#__PURE__*/_jsxs("div", {
      className: classnames(S.grid, S.fill, S.sub),
      children: [/*#__PURE__*/_jsxs(Flex, {
        variant: "rowM",
        className: S.fill,
        children: [/*#__PURE__*/_jsx(Checkbox, {
          id: ids[6],
          variant: "small",
          value: Model.getShowIfEmpty(value),
          eventData: "setShowIfEmpty",
          onChange: onModelChange
        }), /*#__PURE__*/_jsx(Label, {
          variant: "input",
          htmlFor: ids[6],
          children: uiAttributesT('showIfEmpty')
        })]
      }), type.endsWith('@') && /*#__PURE__*/_jsxs(Flex, {
        variant: "rowM",
        className: S.fill,
        children: [/*#__PURE__*/_jsx(Checkbox, {
          id: ids[6],
          variant: "small",
          value: Model.getShowCount(value),
          eventData: "setShowCount",
          onChange: onModelChange
        }), /*#__PURE__*/_jsx(Label, {
          variant: "input",
          htmlFor: ids[6],
          children: t('showCount')
        })]
      }), Model.getShowIfEmpty(value) && /*#__PURE__*/_jsxs("div", {
        className: classnames(S.grid, S.fill, S.sub),
        children: [/*#__PURE__*/_jsx(Label, {
          variant: "input",
          htmlFor: ids[7],
          children: uiAttributesT('emptyValue')
        }), /*#__PURE__*/_jsx(TextInput, {
          id: ids[7],
          disabled: !Model.getShowIfEmpty(value),
          eventData: "setEmptyValue",
          hint: uiAttributesT('emptyValueHint'),
          value: Model.getEmptyValue(value),
          onChange: onModelChange
        }), /*#__PURE__*/_jsx(Label, {
          variant: "input",
          htmlFor: ids[19],
          children: t('emptyIcon')
        }), /*#__PURE__*/_jsx(TextInput, {
          id: ids[18],
          eventData: "setEmptyIcon",
          hint: t('emptyIconHint'),
          value: Model.getEmptyIcon(value),
          onChange: onModelChange
        })]
      }), /*#__PURE__*/_jsx(Label, {
        variant: "input",
        children: uiAttributesT('justify')
      }), /*#__PURE__*/_jsx(Selector, {
        value: Model.getValueJustify(value),
        eventData: "setValueJustify",
        values: [{
          value: null,
          name: uiAttributesT('none')
        }, {
          value: 'left',
          name: uiAttributesT('left')
        }, {
          value: 'center',
          name: uiAttributesT('center')
        }, {
          value: 'right',
          name: uiAttributesT('right')
        }],
        onChange: onModelChange
      }), /*#__PURE__*/_jsx(Label, {
        variant: "input",
        children: uiAttributesT('align')
      }), /*#__PURE__*/_jsx(Selector, {
        eventData: "setValueAlign",
        value: Model.getValueAlign(value),
        values: [{
          value: null,
          name: uiAttributesT('none')
        }, {
          value: 'top',
          name: uiAttributesT('top')
        }, {
          value: 'center',
          name: uiAttributesT('center')
        }, {
          value: 'bottom',
          name: uiAttributesT('bottom')
        }],
        onChange: onModelChange
      })]
    }), /*#__PURE__*/_jsx(Label, {
      variant: "input",
      htmlFor: ids[12],
      children: uiAttributesT('background')
    }), /*#__PURE__*/_jsx(TextInput, {
      id: ids[12],
      eventData: "setBackground",
      hint: uiAttributesT('backgroundHint'),
      value: Model.getBackground(value),
      onChange: onModelChange
    }), /*#__PURE__*/_jsx(Label, {
      variant: "input",
      htmlFor: ids[13],
      children: t('objectFit')
    }), /*#__PURE__*/_jsx(Selector, {
      eventData: "setObjectFit",
      value: Model.getObjectFit(value),
      values: [{
        value: null,
        name: t('none')
      }, {
        value: 'contain',
        name: t('contain')
      }, {
        value: 'cover',
        name: t('cover')
      }, {
        value: 'fill',
        name: t('fill')
      }, {
        value: 'scale-down',
        name: t('scaleDown')
      }],
      onChange: onModelChange
    }), Model.getObjectFit(value) === 'contain' && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Label, {
        variant: "input",
        htmlFor: ids[12],
        children: t('imageBackground')
      }), /*#__PURE__*/_jsx(TextInput, {
        id: ids[19],
        eventData: "setImageBackgroundColor",
        hint: t('imageBackgroundColorHint'),
        value: Model.getImageBackgroundColor(value),
        onChange: onModelChange
      })]
    }), /*#__PURE__*/_jsx(Label, {
      variant: "input",
      htmlFor: ids[14],
      children: t('imageWidth')
    }), /*#__PURE__*/_jsx(NumericInput, {
      id: ids[14],
      eventData: "setImageWidth",
      hint: t('imageWidthHint'),
      value: Model.getImageWidth(value),
      onChange: onModelChange
    }), /*#__PURE__*/_jsx(Checkbox, {
      label: t('percentageWidth'),
      eventData: "setPercentageWidth",
      onChange: onModelChange,
      value: Model.getPercentageWidth(value)
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Label, {
      variant: "input",
      htmlFor: ids[15],
      children: t('imageHeight')
    }), /*#__PURE__*/_jsx(NumericInput, {
      id: ids[15],
      eventData: "setImageHeight",
      hint: t('imageHeightHint'),
      value: Model.getImageHeight(value),
      onChange: onModelChange
    }), /*#__PURE__*/_jsx(Checkbox, {
      label: t('percentageHeight'),
      eventData: "setPercentageHeight",
      onChange: onModelChange,
      value: Model.getPercentageHeight(value)
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Label, {
      variant: "input",
      htmlFor: ids[17],
      children: t('imagePaneVariant')
    }), /*#__PURE__*/_jsx(TextInput, {
      id: ids[15],
      eventData: "setImagePaneVariant",
      hint: t('imagePaneVariantHint'),
      value: Model.getImagePaneVariant(value),
      onChange: onModelChange
    }), /*#__PURE__*/_jsx("h3", {
      className: S.fill,
      children: t('dialog')
    }), /*#__PURE__*/_jsx(Label, {
      variant: "input",
      htmlFor: ids[11],
      children: t('dialogObjectFit')
    }), /*#__PURE__*/_jsx(Selector, {
      eventData: "setDialogObjectFit",
      value: Model.getDialogObjectFit(value),
      values: [{
        value: null,
        name: t('none')
      }, {
        value: 'contain',
        name: t('contain')
      }, {
        value: 'cover',
        name: t('cover')
      }, {
        value: 'fill',
        name: t('fill')
      }, {
        value: 'scale-down',
        name: t('scaleDown')
      }],
      onChange: onModelChange
    }), /*#__PURE__*/_jsx(Label, {
      variant: "input",
      htmlFor: ids[12],
      children: t('dialogImageWidth')
    }), /*#__PURE__*/_jsx(NumericInput, {
      id: ids[12],
      eventData: "setDialogImageWidth",
      hint: t('dialogImageWidthHint'),
      value: Model.getDialogImageWidth(value),
      onChange: onModelChange
    }), /*#__PURE__*/_jsx(Label, {
      variant: "input",
      htmlFor: ids[13],
      children: t('dialogImageHeight')
    }), /*#__PURE__*/_jsx(NumericInput, {
      id: ids[13],
      eventData: "setDialogImageHeight",
      hint: t('dialogImageHeightHint'),
      value: Model.getDialogImageHeight(value),
      onChange: onModelChange
    }), /*#__PURE__*/_jsx(Label, {
      variant: "input",
      htmlFor: ids[18],
      children: t('dialogTitleIcon')
    }), /*#__PURE__*/_jsx(TextInput, {
      id: ids[18],
      eventData: "setDialogTitleIcon",
      hint: t('dialogTitleIconHint'),
      value: Model.getDialogTitleIcon(value),
      onChange: onModelChange
    })]
  });
}
export default /*#__PURE__*/React.memo(AttributeDetailEditor);